export interface NavLink {
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { label: 'Streaming Platform', href: '#player' },
  { label: 'Contextual Engine', href: '#contextual-engine' },
  { label: 'Case Studies', href: '#case-studies' },
];

export const bookDemoLink: NavLink = { label: 'Book a demo', href: '/contact/' };

export const loginLink: NavLink = {
  label: 'Log in',
  href: `https://app${process.env.REACT_APP_ASSET_STAGE === 'dev' ? '-dev' : ''}.pixels.ai/`,
};
